import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PropertyListingService } from '../../../../shared/providers/property-listing.service';
import { LoaderService } from '../../../../shared/providers/loader.service';
import { ValidationService } from '../../../../shared/providers/validation.service';
import { ToastService } from '../../../../shared/providers/toast.service';

@Component({
    selector: 'app-shared-ticker-add',
    templateUrl: './shared-ticker-add.component.html',
    styleUrls: ['./shared-ticker-add.component.css']
})
export class SharedTickerAddComponent implements OnInit {

    constructor(private Toast: ToastService, public Validation: ValidationService, private Loader: LoaderService, private propertyListing: PropertyListingService) { }
    @Input() modalRef: BsModalRef;
    @Input() userId: number = 0;
    @Output() closeModal = new EventEmitter();
    tickerName = '';
    tickerResponse: any;
    selectedticker: any;
    isSubmit = false;
    ngOnInit() {

    }
    showNoData = false;
    searchTickers() {
        this.isSubmit = true;
        if (!this.Validation.IsinValid(this.tickerName)) {
            this.tickerResponse = [];
            this.Loader.display(true);
            try {
                this.propertyListing.GetTickerSymbolsAutocomplete(this.tickerName).subscribe(res => {
                    let response = res["ResultSet"]["Result"];
                    this.tickerResponse = response.filter(x => x["exchDisp"] == "NASDAQ" || x["exchDisp"] == "NYSE" || x["exchDisp"] == "Dow Jones")
                    if (this.tickerResponse.length == 0) {
                        this.showNoData = true;
                    }
                    else {
                        this.showNoData = false
                        this.selectedticker = [];
                    }
                    this.Loader.display(false);
                });
            }
            catch{
                this.Loader.display(false);
            }
        }
    }
    onTickerSelect(tickername, tickersymbol, tickerexchDisp) {
        this.selectedticker = [];
        const tkr =
        {
            name: tickername,
            symbol: tickersymbol,
            exchDisp: tickerexchDisp,
        }
        this.selectedticker.push(tkr);
        this.tickerResponse = [];
        this.showNoData = false;
    }
    onSaveTicker() {
        let ticker = this.selectedticker[0];
        const input =
        {
            Name: ticker.name,
            Symbol: ticker.symbol,
            UserId: this.userId
        }
        console.log(input);
        this.propertyListing.saveTickerSymbolsForAUser(input).subscribe(res => {
          this.Toast.addToast({ title: 'Success', msg: 'Ticker Mapped Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
            this.closeModal.emit(true);
            this.modalRef.hide();
        });
    }
}
